import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { PESTLE_ORDER } from './../../../../../constants';

class RiskEntityPESTLE extends React.Component {

    constructor(props) {
        super(props);
        this.initialState = {
            political:     {count: 0, highlighted: false},
            economic:      {count: 0, highlighted: false},
            social:        {count: 0, highlighted: false},
            technological: {count: 0, highlighted: false},
            legal:         {count: 0, highlighted: false},
            environmental: {count: 0, highlighted: false}
        };
        this.state = null;

        this.buildNewState = this.buildNewState.bind(this);
    }

    componentDidMount() {
            if (this.props.companyScore) {
                this.setState(this.buildNewState(this.props.companyScore.riskEntityPestleCounts));
            }
    }

    buildNewState(serverList) {
        let newState               = Object.assign({}, this.initialState),
            pestleOrder            = PESTLE_ORDER,
            pestleBoxesHighlighted = 2,
            highlightedPestles     = [],
            max;

        for (let i = 0; i < serverList.length; i++) {

            if (serverList[i].id !== "ANY_PESTLE") {
                newState[serverList[i].id].count = serverList[i].totalCount;
            }
        }

        // Determine the two highlighted PESTLE boxes considering the
        // article volume first and then the P-E-S-T-L-E order, second
        for (let i = 0; i < pestleBoxesHighlighted; i++) {
            max = 0;

            for (let j = 0; j < pestleOrder.length; j++) {
                if (newState[pestleOrder[j]].count > max && highlightedPestles.indexOf(pestleOrder[j]) === -1) {
                    max = newState[pestleOrder[j]].count;
                    highlightedPestles[i] = pestleOrder[j];
                }
            }
        }

        // Highlight the highest found PESTLES
        for (let i = 0; i < highlightedPestles.length; i++) {
            newState[highlightedPestles[i]].highlighted = true;
        }

        return newState;
    };


    getFiltersUri() {
        let catFilter = { noOfDays: this.props.days, pestle: this.props.pestle, level: this.props.risk};
        return encodeURIComponent(JSON.stringify(catFilter));
    }

    //DO NOT re-format the tooltip spans as that will remove the spaces between the words
    render() {
        if (!this.state) {
            return <tr><td colSpan="8" className="inline-spinner"></td></tr>
        }

        return (
            <tr>

                <td className="entity-title">
                    <Link className="entity-name"
                          title={this.props.company.title}
                          to={"/entity-dashboard/" + this.props.company.id}>
                        {this.props.company.title}
                    </Link>
                </td>

                <td>
                    <div className="article-sum">
                        <Link to={
                            "/entity-articles?companyId=" + this.props.company.id + "&noOfDays=" + this.props.days}>
                            {this.props.company.totalCount}
                        </Link>
                    </div>
                </td>


                <td className="pestle-squares">
                    <div className={this.state.political.highlighted ? "square red" : "square"}>
                        <Link to={`/trending-entities/${this.props.company.id}/political/${this.getFiltersUri()}`}>
                            <div className="count" data-angle="political">{this.state.political.count}</div>
                        </Link>
                        <div className="tooltip arrow-top">
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.political" />: <span>{this.state.political.count}</span> <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </div>
                    </div>
                </td>

                <td className="pestle-squares">
                    <div className={this.state.economic.highlighted ? "square red" : "square"}>
                        <Link to={`/trending-entities/${this.props.company.id}/economic/${this.getFiltersUri()}`}>
                            <div className="count" data-angle="economic">{this.state.economic.count}</div>
                        </Link>
                        <div className="tooltip arrow-top">
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.economic" />: {this.state.economic.count} <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </div>
                    </div>
                </td>

                <td className="pestle-squares">
                    <div className={this.state.social.highlighted ? "square red" : "square"}>
                        <Link to={`/trending-entities/${this.props.company.id}/social/${this.getFiltersUri()}`}>
                            <div className="count" data-angle="social">{this.state.social.count}</div>
                        </Link>
                        <div className="tooltip arrow-top">
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.social" />: {this.state.social.count} <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </div>
                    </div>
                </td>

                <td className="pestle-squares">
                    <div className={this.state.technological.highlighted ? "square red" : "square"}>
                        <Link to={`/trending-entities/${this.props.company.id}/technological/${this.getFiltersUri()}`}>
                            <div className="count" data-angle="technological">{this.state.technological.count}</div>
                        </Link>
                        <div className="tooltip arrow-top">
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.technological" />: {this.state.technological.count} <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </div>
                    </div>
                </td>

                <td className="pestle-squares">
                    <div className={this.state.legal.highlighted ? "square red" : "square"}>
                        <Link to={`/trending-entities/${this.props.company.id}/legal/${this.getFiltersUri()}`}>
                            <div className="count" data-angle="legal">{this.state.legal.count}</div>
                        </Link>
                        <div className="tooltip arrow-top">
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.legal" />: {this.state.legal.count} <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </div>
                    </div>
                </td>

                <td className="pestle-squares">
                    <div className={this.state.environmental.highlighted ? "square red" : "square"}>
                        <Link to={`/trending-entities/${this.props.company.id}/environmental/${this.getFiltersUri()}`}>
                            <div className="count" data-angle="environmental">{this.state.environmental.count}</div>
                        </Link>
                        <div className="tooltip arrow-top">
                                <FormattedMessage id="General_CoreFunctionality_UIText_general.environmental" />: {this.state.environmental.count} <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </div>
                    </div>
                </td>

            </tr>

        );
    }

}

export default RiskEntityPESTLE;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/TrendingEntitiesPodSingleQuery/RiskEntityPESTLE.jsx